import React, { useEffect, useState, useMemo } from "react"
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap"
import axios from "axios"
import { useLocation } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import LessonAdditionalInfo from "./Card"
import Spinners from "components/Common/Spinner"

const API_URL = "https://topschooldev.prisms.in/rest/index.php/staff_list.json"

const Home = () => {
  const location = useLocation()
  const id = location.state?.id
  const sid = localStorage.getItem("sid")?.replace(/"/g, "")
  const staff_id = localStorage.getItem("user_id")
  const acad_id = localStorage.getItem("acad_id")

  const [result, setResult] = useState([])
  const [classList, setClassList] = useState([])
  const [subjectList, setSubjectList] = useState([])
  const [div_id, setDiv_id] = useState("")
  const [subject_id, setSubject_id] = useState("")
  const [date, setDate] = useState("")
  const [lessonName, setLName] = useState("")
  const [lessonDuration, setLessonDuration] = useState("")
  const [loading, setLoading] = useState(false)
  const lessonDurations = useMemo(
    () => Array.from({ length: 99 }, (_, i) => i + 1),
    []
  )

  useEffect(() => {
    const getAccessableClass = async () => {
      try {
        const response = await axios.post(API_URL, {
          fun_name: "getAccessClass",
          sid,
          staff_id,
        })
        setClassList(response.data.result)
      } catch (error) {
        console.error("Failed to fetch class list:", error)
      }
    }
    getAccessableClass()
  }, [])

  useEffect(() => {
    const getAccessableSubject = async () => {
      if (!div_id) return
      try {
        const response = await axios.post(API_URL, {
          fun_name: "getAccessClassSubject",
          sid,
          staff_id,
          div_id,
        })
        setSubjectList(response.data.result)
      } catch (error) {
        console.error("Failed to fetch subject list:", error)
      }
    }
    getAccessableSubject()
  }, [div_id])

  useEffect(() => {
    const getReportData = async () => {
      if (!id) return
      setLoading(true)
      try {
        const response = await axios.post(API_URL, {
          fun_name: "getLessonPlanByID",
          staff_id,
          sid,
          id,
        })
        const res = response.data.result
        setLoading(false)

        setResult(res)
      } catch (error) {
        setLoading(false)

        console.error("Failed to fetch lesson data:", error)
      }
    }
    getReportData()
  }, [id])

  useEffect(() => {
    if (result.length > 0) {
      const [data] = result
      setDiv_id(data.classdiv_id)
      setSubject_id(data.subject_id)
      setDate(data.month)
      setLName(data.Lessonname)
      setLessonDuration(data.Lessonduration)
    }
  }, [result])

  return (
    <Row className="mt-5 py-4">
      <Container>
        <Card className="shadow-lg rounded-lg p-0">
          {loading ? (
            <Spinners />
          ) : (
            <CardBody className="p-4">
              <h1
                className="text-center mb-4 fs-3"
                style={{ color: "#3c3c3c" }}
              >
                Lesson Plan
              </h1>

              <Row>
                <Col xl="4">
                  <Input
                    type="select"
                    value={div_id}
                    onChange={e => setDiv_id(e.target.value)}
                  >
                    <option value="">Select Class</option>
                    {classList.map(data => (
                      <option key={data.id} value={data.id}>
                        {data.div_name}
                      </option>
                    ))}
                  </Input>
                </Col>

                <Col xl="12" className="mt-3">
                  <Input
                    type="month"
                    value={date}
                    onChange={e => setDate(e.target.value)}
                  />
                </Col>

                <Col xl="4" className="mt-3">
                  <Input
                    type="select"
                    value={subject_id}
                    onChange={e => setSubject_id(e.target.value)}
                  >
                    <option value="">Select Subject</option>
                    {subjectList.map(data => (
                      <option key={data.id} value={data.id}>
                        {data.subject}
                      </option>
                    ))}
                  </Input>
                </Col>

                <Col xl="4" className="mt-3">
                  <Input
                    type="text"
                    placeholder="Lesson Name"
                    value={lessonName}
                    onChange={e => setLName(e.target.value)}
                  />
                </Col>

                <Col xl="4" className="mt-3">
                  <Input
                    type="select"
                    value={lessonDuration}
                    onChange={e => setLessonDuration(e.target.value)}
                  >
                    <option value="">Lesson Duration</option>
                    {lessonDurations.map(num => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </Input>
                </Col>

                <Col xl="4" className="mt-3">
                  <hr />
                </Col>

                <Col xl="4" className="mt-3">
                  {div_id &&
                    subject_id &&
                    date &&
                    lessonDuration &&
                    lessonName && (
                      <LessonAdditionalInfo
                        div_id={div_id}
                        subject_id={subject_id}
                        date={date}
                        lessonDuration={lessonDuration}
                        lessonName={lessonName}
                        sid={sid}
                        staff_id={staff_id}
                        acad_id={acad_id}
                        result={result}
                      />
                    )}
                </Col>
              </Row>
            </CardBody>
          )}
        </Card>
      </Container>
      <ToastContainer />
    </Row>
  )
}

export default Home
